var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HOME_WORK_REQUEST, HOME_WORK_SUCCESS, HOME_WORK_RESET, HOME_WORK_UPDATE } from '../actions/homeworkAction';
var initialState = {
    isFetching: false,
    additionalInfo: []
};
export function homeworkReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case HOME_WORK_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case HOME_WORK_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, additionalInfo: action.payload });
        case HOME_WORK_UPDATE:
            return __assign(__assign({}, state), { isFetching: false, additionalInfo: action.payload });
        case HOME_WORK_RESET:
            return __assign(__assign({}, state), { isFetching: false, additionalInfo: [] });
        default:
            return state;
    }
}
;
export function getCurrenHomework(state) {
    return state.homework;
}
//# sourceMappingURL=homework.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HOME_WORK_REQUEST, HOME_WORK_SUCCESS, HOME_WORK_RESET, HOME_WORK_UPDATE } from '../actions/homeworkAction';
var initialState = {
    isFetching: false,
    additionalInfo: []
};
export function homeworkReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case HOME_WORK_REQUEST:
            return __assign(__assign({}, state), { isFetching: true });
        case HOME_WORK_SUCCESS:
            return __assign(__assign({}, state), { isFetching: false, additionalInfo: action.payload });
        case HOME_WORK_UPDATE:
            return __assign(__assign({}, state), { isFetching: false, additionalInfo: action.payload });
        case HOME_WORK_RESET:
            return __assign(__assign({}, state), { isFetching: false, additionalInfo: [] });
        default:
            return state;
    }
}
;
export function getCurrenHomework(state) {
    return state.homework;
}
//# sourceMappingURL=homework.js.map